import $ from "jquery";

import Field from "./../field";
import Dropdown from "./dropdown";
import Api from "./../../common/Api/states";

const State = (($) => {
  return (field) => {
    const dropdown = new Dropdown({ ...field, options: [] });

    Api.list("US").done((response) => {
      const options = [];

      response.forEach((row) => {
        options.push({ label: row.stateName, value: row.stateID });
      });

      dropdown.setOptions(options);
    });

    return dropdown;
  };
})($);

export default State;
